'use strict';

function widgetIdFactory(sharedConfig) {

    return {
        generate: generate,
        isValid: isValid
    };

    function generate() {

        return [
            sharedConfig.WIDGET_PREFIX,
            _generateRandomNumber()
        ].join('-');
    }

    function isValid(widgetId) {
        var isValidWidgetIdRegExp = new RegExp('^' + sharedConfig.WIDGET_PREFIX + '-[0-9]+$');
        return isValidWidgetIdRegExp.test(widgetId);
    }

    function _generateRandomNumber() {
        var randomNumberAsString = '' + Math.random(),
            randomId = randomNumberAsString.replace('0.', '');

        return randomId;
    }
}

define('shared/widgetId', ['shared/config'], function (sharedConfig) {
    return widgetIdFactory(sharedConfig);
});



//////////////////
// WEBPACK FOOTER
// ./src/shared/widgetId.js
// module id = 0
// module chunks = 0 1